(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('FavoritesData', FavoritesData);

    function FavoritesData() {

        return {
            oltList: {
                type: 'state',
                state: 'olt'
            },
            oltAdd: {
                type: 'modal',
                service: 'OltService',
                method: 'addOltModalConstructor'
            },
            alarmList: {
                type: 'state',
                state: 'alarms'
            },
            onuList: {
                type: 'state',
                state: 'onu'
            },
            bridgeList: {
                type: 'state',
                state: 'provisioning'
            },
            bridgeAdd: {
                type: 'modal',
                service: 'BridgeService',
                method: 'addBridgeModalConstructor'
            },
            gtpList: {
                type: 'state',
                state: 'provisioning'
            },
            gtpAdd: {
                type: 'modal',
                service: 'GtpService',
                method: 'addGtpModalConstructor'
            },
            packetRuleList: {
                type: 'state',
                state: 'provisioning'
            },
            packetRuleAdd: {
                type: 'modal',
                service: 'PacketRuleService',
                method: 'addPacketRuleModalConstructor'
            },
            userList: {
                type: 'state',
                state: 'config'
            },
            userAdd: {
                type: 'modal',
                service: 'UserService',
                method: 'addUserModalConstructor'
            },
            systemConfiguration: {
                type: 'state',
                state: 'config'
            },
            systemBackup: {
                type: 'modal',
                service: 'SystemConfigService',
                method: 'backupFromFavorite'
            },
            systemBackupRestore: {
                type: 'modal',
                service: 'SystemConfigService',
                method: 'listBackupModalConstructor'
            }
        };

    }
})();